module.exports = __webpack_public_path__ + "img/link-45deg.d4d8a428.svg";